import { useProject } from '@customink/project-service-react-components';

export const useProjectTotalQuantity = () => {
  const { data: project } = useProject();
  if (!project || !project.items) {
    return 0;
  }
  return project.items.reduce(
    (acc, item) => acc + (item.totalQuantity ?? 0),
    0,
  );
};
